import FollowUpCalendar from "./FollowUpCalendar";

export default FollowUpCalendar;
